// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7674 ? "ca377847" : chunkId) + "." + {"823":"406140f6799900b7","7674":"a9d94e0707641dd8"}[chunkId] + ".js";
};